import { getFunnelStageLabel } from '@/constants/salesFunnel'
import { formatCnpj } from '@/components/PjAgrada/pjAgradaFormat'

export const CLIENTE_AGRADA_STATUS_LABELS: Record<string, string> = {
  CLIENTE_ATIVO: 'Cliente ativo',
  PROSPECT: 'Prospect',
  INATIVO: 'Inativo',
  CHURNED: 'Churned',
}

export const HISTORICO_TIPO_LABELS: Record<string, string> = {
  cadastro: 'Cadastro',
  cliente_ativo: 'Cliente ativo',
  deal: 'Deal',
  projeto: 'Projeto',
  chamado: 'Chamado',
  atividade: 'Atividade',
}

export function formatClienteAgradaStatus(status: string): string {
  return CLIENTE_AGRADA_STATUS_LABELS[status] ?? status.replace(/_/g, ' ')
}

export function displayOrDash(value?: string | null): string {
  const trimmed = value?.trim()
  return trimmed ? trimmed : '—'
}

export function formatClienteCnpj(cnpj?: string | null): string {
  if (!cnpj?.trim()) return '—'
  return formatCnpj(cnpj)
}

export function formatDealEtapa(etapa: string): string {
  return getFunnelStageLabel(etapa)
}

export function getClienteInitials(nome: string): string {
  const parts = nome.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
}
